import { HighlightBannerBookForm } from './HighlightBannerBookForm'
import { withHighlightBannerBookForm } from './withHighlightBannerBookForm'

const Connected = withHighlightBannerBookForm(HighlightBannerBookForm)

export { Connected as HighlightBannerBookForm }
